import { noTagPage, getById } from '@/api/business/crmCustomer'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(noTagPage, getById)
